module.exports = __webpack_public_path__ + "media/icons/geometry70 (1)-0e020cc6.png";